import { classification_select, state_select } from "Explore/Config/FilterData";
import { ShadcnSelectListFilters } from "Explore/Components";

const FiltersInstitutionLandscape = ({ filters, setFilters }) => {
  return (
    <div className="flex flex-col gap-6 p-4 border border-gray-100 rounded-md bg-white shadow-sm mt-4">
      <p className="text-sm font-semibold text-gray-800">Filters</p>
      
      <div className="flex flex-col gap-2">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Classification
        </label>
        <ShadcnSelectListFilters
          placeholder={"Classification"}
          options={classification_select}
          filters={filters}
          setFilters={setFilters}
          entity={"classifications"}
        />
      </div>
      
      <div className="flex flex-col gap-2">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          State
        </label>
        <ShadcnSelectListFilters
          placeholder={"State"}
          options={state_select}
          filters={filters}
          setFilters={setFilters}
          entity={"states"}
        />
      </div>
    </div>
  );
};

export default FiltersInstitutionLandscape;
